export default __webpack_public_path__ + "static/media/product.360395dc.jpg";